import { render, staticRenderFns } from "./bomSheet.vue?vue&type=template&id=243d2be8&scoped=true&"
import script from "./bomSheet.vue?vue&type=script&lang=js&"
export * from "./bomSheet.vue?vue&type=script&lang=js&"
import style0 from "./bomSheet.vue?vue&type=style&index=0&id=243d2be8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243d2be8",
  null
  
)

export default component.exports